module.exports = __webpack_public_path__ + "media/images/icons/icon_logout-d077e5faae789f513cf22ae5ce99e5b4.svg";